import { render, staticRenderFns } from "./GeographicalDistributionUpdate.vue?vue&type=template&id=6fa5515d&"
import script from "./GeographicalDistributionUpdate.vue?vue&type=script&lang=js&"
export * from "./GeographicalDistributionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports